import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../config/axios";
const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [role, setRole] = useState("Contractor");

  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(false);
  const id = sessionStorage.getItem("customer_id");
  const token = sessionStorage.getItem("access_token");
  const fetchUserProfile = async () => {
    setLoading(true);
    try {
      if (!token) {
        setRole(null);
        return;
      }

      const response = await axios.get(
        `${BASE_URL}/user/userviewbyemail/${id}/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setProfile(response.data);

      setRole(response.data.role);
    } catch (error) {
      setRole(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  return (
    <UserContext.Provider
      value={{ role, loading, refreshProfile: fetchUserProfile }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};
